export const Baseurl = "https://fromhome.assexfinance.com/public_html/api/";

export const Mediaurl =
  "https://fromhome.assexfinance.com/public_html/public/storage/coursematerials//";

// export const Baseurl = 'https://fromhome.adebayogreat.dev/backend/api/';

// export const Mediaurl = 'https://fromhome.adebayogreat.dev/backend/public/storage/coursematerials/';
